module.exports = __webpack_public_path__ + "img/logo.57df6563.svg";